import { Screen } from '../../components/Screen/Screen';
import './HomePage.css';

export function HomePage() {

  return (
    <Screen title="Top stories">
      <p className="home-page__intro">
        A lean, mobile-first news prototype. Use the bottom nav to explore.
      </p>

      <section className="home-page__section">
      </section>
    </Screen>
  );
}
